<template>
  <v-container
    fluid
  >
    <Register-digi-board
      v-if="showRegisterDialog"
      :digiboardid="digiBoardExternalId"
      @success="fillData"
      @closed="showRegisterDialog = false"
    />
    <re-register-alert-dialog
      v-if="showReRegisterAlertDialog"
      title="Do you want to proceed ?"
      message="This action will unlink your licence and remove the connection from the device it's been registered on."
      confirm-button="Yes"
      cancel-button="No"
      @closed="showReRegisterAlertDialog = false"
      @confirmed="openReRegisterConfirmForm()"
    />
    <re-register-digiboard-licence
      v-if="showReRegisterDialog"
      :digiboardid="digiBoardExternalId"
      @success="fillData"
      @closed="showReRegisterDialog = false"
    />
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-monitor-lock
      </v-icon> Digi-Board Licence
    </h2>
    <v-card
      color="#CFD8DC"
      shaped
    >
      <v-container
        fluid
      >
        <delete-licence
          v-if="showDelete"
          :title="'Cancel Licence?'"
          :message="'This action will cancel your licence subscription.'"
          @closed="showDelete = false"
          @confirmed="deleteConfirmed()"
        />
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-card
              color="#eceff1"
              class="licence-content-style"
            >
              <v-card-title class="justify-center">
                <h3
                  class="mt-2 my-title-style"
                >
                  Licence Contents
                </h3>
              </v-card-title>
              <br>
              <v-col
                v-if="showLicenceContent"
                cols="12"
                lg="12"
                class="text-right"
              >
                <div>
                  <v-btn
                    v-if="showRegisterBtn"
                    color="#37474F"
                    @click="registerDigiBoard()"
                  >
                    Register
                  </v-btn>
                  <v-btn
                    v-if="isLicenceRegistered"
                    color="#37474F"
                    @click="reRegisterDigiBoard()"
                  >
                    Re-Register
                  </v-btn>
                  <v-btn
                    v-if="showCancelButton"
                    color="#FF3700"
                    @click="cancelLicence(digiBoardLicenceContent.id)"
                  >
                    Cancel
                  </v-btn>
                </div>
              </v-col>
              <p
                v-if="!showLicenceContent"
                class="licence-alert-color"
              >
                <br>
                No licence found for this digi-board.
              </p>
              <v-container>
                <div
                  v-if="showLicenceContent"
                  flat
                  color="#eceff1"
                  class="ml-5"
                >
                  <p class="my-p-style">
                    Licence Status:
                    <font
                      :color="getColor(digiBoardLicenceContent.active)"
                      bold
                    >
                      {{ digiBoardLicenceContent.active | statusUpdate }}
                    </font>
                  </p>
                  <p
                    v-if="digiBoardLicenceContent.registered_at !== null"
                    class="my-p-style"
                  >
                    Registered At:-
                    <font class="font-my-style">
                      {{ digiBoardLicenceContent.registered_at | convertStringToLocalDatetime }}
                    </font>
                  </p>
                  <p
                    v-else
                    class="my-p-style"
                  >
                    Registered At:-
                    <font class="font-my-style">
                      N/A
                    </font>
                  </p>
                  <p class="my-p-style">
                    Licence Active From:-
                    <font class="font-my-style">
                      {{ digiBoardLicenceContent.start | convertStringToLocalDatetime }}
                    </font>
                  </p>
                  <p class="my-p-style">
                    Licence Active To:-
                    <font class="font-my-style">
                      {{ digiBoardLicenceContent.end | convertStringToLocalDatetime }}
                    </font>
                  </p>
                </div>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
 <script>
 import RegisterDigiBoard from './RegisterDigiBoard.vue';
 import spinner from 'src/views/dashboard/component/SpinnerCentre';
 import moment from 'moment';
 import DeleteDialog from 'src/views/dashboard/component/DeleteDialog';
 import Constants from 'src/constants';
 import ReRegisterDigiBoardLicence from './ReRegisterDigiBoardLicence.vue';

  export default {
    name: 'DigiBoardLicenceDetails',
    components: {
      'Register-digi-board': RegisterDigiBoard,
      'centre-spinner': spinner,
      'delete-licence': DeleteDialog,
      're-register-alert-dialog': DeleteDialog,
      're-register-digiboard-licence': ReRegisterDigiBoardLicence,
    },
    filters: {
      convertStringToLocalDatetime (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      statusUpdate (warranty) {
        if (warranty === true) return 'Active*';
        else return 'Inactive';
      },
    },
    data () {
      return {
        showRegisterDialog: false,
        loading: false,
        showDelete: false,
        licenceId: '',
        showReRegisterAlertDialog: false,
        showReRegisterDialog: false,
        digiBoardExternalId: '',
      };
    },
    computed: {
      digiBoardLicenceContent () {
        return this.$store.getters['digiboards/getDigiBoardLicenceContent'];
      },
      showLicenceContent () {
        return Object.keys(this.digiBoardLicenceContent).length > 0;
      },
      showCancelButton () {
        return this.digiBoardLicenceContent.active === true;
      },
      showRegisterBtn () {
        return (this.digiBoardLicenceContent !== null && this.digiBoardLicenceContent.registered_at === null && this.digiBoardLicenceContent.active === true);
      },
      isLicenceRegistered () {
        return (this.digiBoardLicenceContent !== null && this.digiBoardLicenceContent.registered_at !== null && this.digiBoardLicenceContent.active === true);
      },
    },
    async mounted () {
      await this.fillData();
    },
    methods: {
      registerDigiBoard () {
        const digiBoardId = this.$route.params.id;
        this.digiBoardExternalId = digiBoardId;
        this.showRegisterDialog = true;
      },
      async fillData () {
        this.loading = true;
        const digiBoardId = this.$route.params.id;
        await this.$store.dispatch('digiboards/fetchDigiBoardLicenceContent', {
          params: {
            digiBoardId: digiBoardId,
          },
        }).then(response => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      getColor (active) {
        if (active === true) return 'green';
        else return 'red';
      },
      cancelLicence (boardId) {
        this.showDelete = true;
        this.licenceId = boardId;
      },
      async deleteConfirmed () {
        this.loading = true;
        await this.$store.dispatch('digiboards/deleteLicence', this.licenceId)
          .then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Licence deleted.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
          }).finally(
            this.loading = false,
            this.showDelete = false,
            this.licenceId = '',
            this.fillData(),
          );
      },
      openReRegisterConfirmForm () {
        const deviceExternalId = this.$route.params.id;
        this.digiBoardExternalId = deviceExternalId;
        this.showReRegisterAlertDialog = false;
        this.showReRegisterDialog = true;
      },
      reRegisterDigiBoard () {
      this.showReRegisterAlertDialog = true;
    },
    },
  };
</script>
<style scoped>
.licence-content-style {
    min-height: 394px;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.my-title-style {
  color: #546e7a;
}
@media (max-width: 960px) {
  .title-style {
    margin-top: -20px;
  }
}
.licence-alert-color {
  color: #FF3700;
  text-align: center;
}
.font-my-style {
  font-weight: bold;
  font-size: 15px;
  color: #37474F;
}
.my-p-style {
    font-size: 16px;
    font-weight: bold;
    color: #546E7A;
    font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}
.cancel-btn-style {
  padding-top: 25px;
}
</style>
